import SurveyUtils from "./SurveyUtils";

export function shouldShowLecturer(selectedProgram, fundingAreas) {
  if (selectedProgram) {
    return SurveyUtils.isSemesterTypeProgram(selectedProgram.name);
  }

  // Use all available programs, independently of report, search and area filters.
  const programs = (fundingAreas || []).flatMap(area => area.programs || []);
  return programs.length > 0 && programs.every(program => SurveyUtils.isSemesterTypeProgram(program.name));
}
